import React, { useState } from 'react';
import { Close } from '@mui/icons-material';
import {
  Button,
  Dialog,
  Grid,
  IconButton,
  Typography,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio
} from '@mui/material';

import {
  gray100,
  gray90,
  gray80,
  primaryButtonBackgroundColor,
  primaryColor,
  errorColor
} from '../../constants/Colors';

import { userRoleEnum } from '../../constants/Enum';

const modalStyles = {
  button: {
    boxSizing: 'border-box',
    height: '44px',
    width: '100%'
  },
  dialog: {
    '& .MuiDialog-paper': {
      m: '16px',
      width: '560px',
      p: '24px'
    }
  },
  text: {
    color: gray100,
    fontSize: '16px',
    mt: '24px'
  },
  title: {
    color: gray100,
    fontSize: '22px',
    fontWeight: '500'
  },
  dialogRadio: {
    '&.Mui-checked': {
      color: primaryColor
    },
    color: gray90
  },
  dialogRadioLabel: {
    '& .Mui-disabled': {
      color: gray80
    },
    color: gray100
  },
  dialogRadioWrapper: {
    flexDirection: 'row',
    mb: '36px'
  },
  label: {
    fontSize: '14px'
  },
  required: {
    color: errorColor,
    fontSize: '14px',
    marginLeft: '8px'
  }
};

interface ModalProps {
  onClose: (open: boolean) => void;
  open: boolean;
  onEdit: (selectedRole?: number | null) => Promise<void>;
  role?: number | null;
}

const EditMemeberModal: React.FC<ModalProps> = (props) => {
  const { open, onClose, onEdit, role } = props;
  const [selectedRole, setSelectedRole] = useState(role);

  return (
    <Dialog open={open} sx={modalStyles.dialog}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Typography sx={modalStyles.title}>権限変更</Typography>
        <IconButton onClick={() => onClose(open)}>
          <Close />
        </IconButton>
      </Grid>

      <Typography sx={[modalStyles.text, { mb: '24px' }]}>
        代表者の権限を別のユーザーに譲渡すると、その後の役割は共有者に変更されます。
      </Typography>

      <Typography align="left" component="div">
        <Typography color={gray100} component="span" sx={modalStyles.label}>
          権限
        </Typography>
        <Typography component="span" sx={modalStyles.required}>
          必須
        </Typography>
      </Typography>
      <FormControl>
        <RadioGroup
          defaultValue={role}
          onChange={(e) => setSelectedRole(parseInt(e.target.value, 10))}
          sx={modalStyles.dialogRadioWrapper}
        >
          <FormControlLabel
            control={<Radio sx={modalStyles.dialogRadio} />}
            label="代表者"
            sx={[modalStyles.dialogRadioLabel, { m: '0 24px 0 0' }]}
            value={userRoleEnum.leader}
          />
          <FormControlLabel
            control={<Radio sx={modalStyles.dialogRadio} />}
            label="共有者"
            sx={[modalStyles.dialogRadioLabel, { m: '0 24px 0 0' }]}
            value={userRoleEnum.member}
          />
        </RadioGroup>
      </FormControl>
      <Button
        onClick={() => onEdit(selectedRole)}
        sx={[primaryButtonBackgroundColor, modalStyles.button]}
        variant="contained"
      >
        保存
      </Button>
    </Dialog>
  );
};

export default EditMemeberModal;
